const HomePage = () => import('@/pages/home/HomePage.vue');

const routes = [
  {
    path: '/home',
    name: 'HomePage',
    id: 'home',
    component: HomePage,
    linkText: 'navBar.workpackages',
    meta: { titleExtension: 'navBar.workpackages' },
    index: 2,
  },
];

export default routes;
